import type React from 'react';
import { range } from 'lodash-es';

import { FormField, Label, Select } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { MAXIMUM_NUMBER_OF_OCCUPANTS } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_OCCUPANTS = 99;
const MAX_COMMON_AREA_PEOPLE = 99;

// Generate options from 1 to max
const occupantsOptions = range(1, MAX_OCCUPANTS + 1).map((value) => ({
  value: String(value),
  label: `${value} ${value === 1 ? 'person' : 'people'}`,
}));

const commonAreaOptions = range(1, MAX_COMMON_AREA_PEOPLE + 1).map((value) => ({
  value: String(value),
  label: `${value} ${value === 1 ? 'person' : 'people'}`,
}));

function MaximumNumberOfOccupants_v2({ section, setSectionValues }: Props) {
  function onMaximumOccupancyChange(event: React.ChangeEvent<HTMLSelectElement>): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS]: Number(event.target.value),
    });
  }
  function onMaximumCommonAreaPeopleChange(event: React.ChangeEvent<HTMLSelectElement>): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_PEOPLE_COMMON_AREA]: Number(event.target.value),
    });
  }

  const maximumOccupants = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS),
  );
  const maximumCommonAreaPeople = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_PEOPLE_COMMON_AREA),
  );

  return (
    <>
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>What is the maximum number of persons permitted in the rental unit at any time?</Label>}
        control={
          <Select value={String(maximumOccupants)} onChange={onMaximumOccupancyChange}>
            {occupantsOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        }
      />
      <FormField
        required
        label={
          <Label>
            What is the maximum number of people permitted within the common areas of your building at any time?
          </Label>
        }
        control={
          <Select value={String(maximumCommonAreaPeople)} onChange={onMaximumCommonAreaPeopleChange}>
            {commonAreaOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        }
      />
    </>
  );
}

MaximumNumberOfOccupants_v2.description =
  'Allow Irene to set the maximum number of people within the unit and common areas';

export default MaximumNumberOfOccupants_v2;
